export function animalSpeciesHelper(value: string) {
  switch (value.toLowerCase()) {
    case 'beef':
      return { label: 'Beef', order: 0, value };

    case 'hog':
      return { label: 'Hog', order: 1, value };

    case 'bison':
      return { label: 'Bison', order: 2, value };

    case 'lamb':
      return { label: 'Lamb', order: 3, value };

    case 'goat':
      return { label: 'Goat', order: 4, value };

    // Wild game, grouped together so they sit adjacent in species pickers.
    // `venison` is DEER specifically — labelled so it cannot be mistaken for an
    // umbrella covering the elk/moose entries beneath it.
    case 'venison':
      return { label: 'Deer (Venison)', order: 5, value };

    case 'elk':
      return { label: 'Elk', order: 6, value };

    case 'moose':
      return { label: 'Moose', order: 7, value };

    case 'antelope':
      return { label: 'Antelope', order: 8, value };

    case 'bear':
      return { label: 'Bear', order: 9, value };

    case 'yak':
      return { label: 'Yak', order: 10, value };

    case 'veal':
      return { label: 'Veal', order: 11, value };

    case 'alligator':
      return { label: 'Alligator', order: 12, value };

    default:
      return { label: value, order: 99, value };
  }
}
